import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AfricaNendaLogo from '../components/AfricaNendaLogo';
import SupportContact from '../components/SupportContact';
import { TERMS_SECTIONS, TERMS_UPDATED, TERMS_VERSION } from '../data/terms';

const Bullets = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1.5 text-sm text-gray-700">
    {items.map((b) => <li key={b}>{b}</li>)}
  </ul>
);

/** The terms of service, public: the application wizard links here and opens it in a new tab. */
export default function Terms() {
  const { hash } = useLocation();

  // Opened in a new tab at /terms#data, the section exists only once React has
  // rendered, after the browser has already tried to scroll to it.
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
  }, [hash]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-100 py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-6">
          <AfricaNendaLogo className="h-10 mx-auto mb-3" />
          <h1 className="text-2xl font-bold text-gray-900">Terms of service</h1>
          <p className="text-sm text-gray-500 mt-1">AfricaNenda IIPS Sandbox · version {TERMS_VERSION} · {TERMS_UPDATED}</p>
        </div>

        <div className="bg-white rounded-xl shadow-xl p-6 sm:p-8">
          <nav aria-label="Sections" className="mb-6 pb-6 border-b border-gray-100">
            <p className="text-xs font-medium text-gray-500 mb-2">On this page</p>
            <ol className="grid sm:grid-cols-2 gap-x-6 gap-y-1 text-sm list-decimal pl-5">
              {TERMS_SECTIONS.map((s) => (
                <li key={s.id}><a href={`#${s.id}`} className="text-primary-600 hover:text-primary-700">{s.title}</a></li>
              ))}
              <li><a href="#contact" className="text-primary-600 hover:text-primary-700">Contact</a></li>
            </ol>
          </nav>

          <div className="space-y-7">
            {TERMS_SECTIONS.map((s, i) => (
              <section key={s.id} id={s.id} className="scroll-mt-6 space-y-2.5">
                <h2 className="text-base font-semibold text-gray-900">{i + 1}. {s.title}</h2>
                {(s.paragraphs || []).map((p) => <p key={p} className="text-sm text-gray-700">{p}</p>)}
                {s.bullets && <Bullets items={s.bullets} />}
                {(s.more || []).map((m) => (
                  <div key={m.lead} className="space-y-2.5 pt-1">
                    <p className="text-sm text-gray-700">{m.lead}</p>
                    <Bullets items={m.bullets} />
                  </div>
                ))}
                {s.after && <p className="text-sm text-gray-700">{s.after}</p>}
              </section>
            ))}

            <section id="contact" className="scroll-mt-6 space-y-2.5">
              <h2 className="text-base font-semibold text-gray-900">{TERMS_SECTIONS.length + 1}. Contact</h2>
              <SupportContact body
                lead="Questions about these terms or about your data: email AfricaNenda at"
                subject="AfricaNenda IIPS Sandbox terms of service" />
            </section>
          </div>
        </div>

        <p className="text-center text-xs text-gray-500 mt-4">
          <Link to="/register" className="text-primary-600 font-medium">Apply to join</Link>
          <span className="mx-2">·</span>
          <Link to="/login" className="text-primary-600 font-medium">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
